module.exports = __webpack_public_path__ + "static/media/ENDLESSBUMMER-Regular.c6832629.otf";